import { ABTestExperiment, ExperimentId, ExperimentTag, isSegmentValid, SegmentId } from "../experiments"

import { updateHistory } from "../history"

export const loadOrGenerateSegment = <T = ExperimentId>(
    experiment: ABTestExperiment<T>,
    computeNewSegmentValue: (experiment: ABTestExperiment<T>) => SegmentId,
    enabledExperiments: readonly ABTestExperiment<T>[],
    history: ExperimentTag<T>[],
): { segmentId: SegmentId; history: ExperimentTag<T>[] } => {
    const cookieTag = experimentFromId(experiment.id, history)
    if (cookieTag && isSegmentValid(cookieTag.segmentId)) {
        const newHistory = updateHistory(cookieTag, enabledExperiments, history)
        return { segmentId: cookieTag.segmentId, history: newHistory }
    }

    const newExperimentTag: ExperimentTag<T> = {
        experimentId: experiment.id,
        segmentId: computeNewSegmentValue(experiment),
    }
    const newHistory = updateHistory(newExperimentTag, enabledExperiments, history)
    return { segmentId: newExperimentTag.segmentId, history: newHistory }
}

export const defaultComputeNewSegmentValue = <T = ExperimentId>(experiment: ABTestExperiment<T>): SegmentId => {
    const value = Math.random()
    return value <= experiment.weighting ? "a" : "b"
}

const experimentFromId = <T>(experimentId: T, experiments: ExperimentTag<T>[]) =>
    experiments.find((e) => e.experimentId == experimentId)
